import React, { FC } from 'react';

import { Root } from './index.styled';

interface Props {
  src: string;
  alt: string;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

const Image: FC<Props> = ({ src, alt, onMouseOver, onMouseOut }) => {
  return (
    <Root src={src} alt={alt} onMouseOver={onMouseOver} onMouseOut={onMouseOut} />
  );
};

export default Image;
